import { Grid } from "@mui/material";
import FloorList from "src/components/shared-components/floor-list";
import { useTranslate } from "src/locales";

interface Props {
  onChange: (val: any) => void;
  buildingId?: number;
}

export default function FloorFilter({ onChange, buildingId }: Props) {
  const { t } = useTranslate();
  const isDisabled = !buildingId || buildingId === -1;

  return (
    <Grid item xs={12} sm={6} md={2}>
      <FloorList
        handleChange={onChange}
        hbId={buildingId || -1}
        sx={{ width: "100%" }}
        disabled={isDisabled}
        placeholder={isDisabled ? t("nurse-surgery-procedure.select-building-first") || "Önce bina seçilmeli" : undefined}
      />
    </Grid>
  );
}
